module.exports = __webpack_public_path__ + "static/media/add-image.5120e417.svg";